<script setup>
import { ref } from "vue"
import { onMounted } from 'vue'
import { $bus } from '../common/events'

const props = defineProps({
  headers: {
    type: Array,
    default: [
      /*
      { name: "check", type: "checkbox" },
      { name: "name", text: "Naziv artikla", type: "highlight", sortable: false },
      { name: "sku", text: "SKU" },
      { name: "stock", text: "Zaloga" },
      { name: "comment", text: "Opozorila" },
      { name: "action", text: "Ukazi", type: "action", class: "text-right" },
      */
    ]
  },
  rows: {
    type: Object,
    default: [ ]
  }
});

let table = {
  headers: [

  ],
  rows: [
    //{ id: "100224", name: "Vege sendvič", sku: "100224", stock: "B24: 3 kos, B25: 10 kos, B26: prazno", comment: "Preveri rok uporabe", warning: true },
    //{ id: "100225", name: "Tuna sendvič", sku: "100225", stock: "B24: 3 kos, B25: zadnji kos" },
  ]
};

//const headers = ref(props.headers);
//const rows = ref(props.rows);
</script>

<template>
  <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        <tr>
          <slot name="header">
            <template v-for="header in headers">
              <th scope="col" class="p-4" v-if="header.type == 'checkbox'">
                <div class="flex items-center">
                  <input id="checkbox-all-search" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                  <label for="checkbox-all-search" class="sr-only">checkbox</label>
                </div>
              </th>
              <th scope="col" class="px-6 py-3" :class="header.class" v-else>
                {{ header.text }}
              </th>
            </template>
          </slot>
        </tr>
      </thead>
      <tbody>
        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" v-for="row in rows" v-if="rows && rows.length > 0">
          <slot name="row" v-bind="row">
            <template v-for="header in headers" v-if="row.mode != 'edit'">
              <td class="w-4 p-4" v-if="header.type == 'checkbox'">
                <div class="flex items-center">
                  <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                  <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
                </div>
              </td>

              <td class="flex flex-row items-end justify-end px-0 py-0 space-x-0" v-else-if="header.type == 'action'">
                <button type="button" @click="$emit('editRequest')" class="bg-transparent border-l aspect-square text-blue-700 hover:text-white hover:bg-blue-800 focus:outline-none focus:ring-blue-300 font-medium text-sm w-12 px-1 py-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"><i class="fa fa-pencil"></i></button>
                <button type="button" @click="$emit('deleteRequest')" class="bg-transparent border-l aspect-square text-pink-700 hover:text-white hover:bg-pink-800 focus:outline-none focus:ring-pink-300 font-medium text-sm w-12 px-1 py-1 text-center dark:bg-pink-600 dark:hover:bg-pink-700 dark:focus:ring-pink-800"><i class="fa fa-trash"></i></button>
              </td>

              <td scope="row" class="px-6 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white" v-else-if="header.type == 'highlight'">
                {{ row[header.name] }}
              </td>

              <td class="px-6 py-2" v-else>
                {{ row[header.name] }}
              </td>
            </template>
          </slot>
          <slot name="row-edit" v-bind="row">
            <td colspan="99" class="p-4" v-if="row.mode == 'edit'">
              (no editable component set)
            </td>
          </slot>
        </tr>
        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" v-if="!rows || rows.length == 0">
          <td scope="row" colspan="99" class="px-4 py-8 text-gray-900 text-center whitespace-nowrap dark:text-white">
            <slot name="blank">
              No items to display.
              <!-- Loading animation -->
              <!-- Message -->
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mt-4">
    <slot name="summary">
      <!-- Found 12 items. -->
    </slot>
  </div>

  <!-- Page buttons -->
  <!--<div style="position: absolute; bottom: 16px; right: 20px;">
    <Pagination :itemsPerPage="8" :itemsCount="rows.length" class="overflow-x-auto"></Pagination>
  </div>
  <div class="text-gray-400 mb-1" style="position: absolute; bottom: 16px; left: 20px;">
    <span>Found 3 items. Displaying page 1 of 100.</span>
    <span>8 artiklov ustreza iskanim kriterijem</span>
    <span>Skupaj 8 artiklov</span>
  </div>-->

</template>

<style scoped>
</style>
